import { type DocumentNode, parse, print } from 'graphql';

export function gql(strings: TemplateStringsArray, ...values: unknown[]): DocumentNode {
  const source = strings.reduce(
    (acc, s, i) => acc + s + (i < values.length ? String(values[i]) : ''),
    ''
  );
  return parse(source);
}

export const getQueryString = (query: DocumentNode | string): string => {
  if (typeof query === 'string') return query;
  return print(query);
};
